///////////////////////////////////////////////////////
// This file contains configs that affect layout     //
// NOTE: these are just some of the relevant configs //
// Most of the work happens in components.           //
///////////////////////////////////////////////////////

// Note: These come from the layout asset nowadays by default.
//       To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeLayouts func)

// There are 2 SearchPage variants that can be used:
// 'map' & 'grid'
export const searchPage = {
  variantType: 'map',
};

// ListingPage has 2 layout options: 'coverPhoto' and 'carousel'.
// - 'coverPhoto' means a layout where there's a hero section with cropped image in the beginning of the page
// - 'carousel' shows image carousel, where listing images are shown with the original aspect ratio
export const listingPage = {
  variantType: 'carousel',
};

export const ASPECT_WIDTH_LISTING = 157;
export const ASPECT_HEIGHT_LISTING = 74;

/** Shared crop settings for listing cover photos and digital media card covers (157:74). */
export const MEDIA_CARD_CROP_PROPS = {
  aspectWidth: ASPECT_WIDTH_LISTING,
  aspectHeight: ASPECT_HEIGHT_LISTING,
  minWidth: 600,
  minHeight: Math.round((600 * ASPECT_HEIGHT_LISTING) / ASPECT_WIDTH_LISTING),
};

// ListingImage currently supports only one variant type, but it has aspectRatio as an extra configuration.
export const listingImage = {
  variantType: 'cropImage',
  // Aspect ratio for listing image variants (width/height)
  // Note: This will be converted to separate aspectWidth and aspectHeight values
  // to make calculations easier.
  aspectRatio: `${ASPECT_WIDTH_LISTING}/${ASPECT_HEIGHT_LISTING}`,
  // Listings have custom image variants, which are named here.
  variantPrefix: 'listing-card',
};
